import Link from '@components/Link'

export const RequestHelp = () => {
    return (<Link external target="_blank" href={'https://digitalplatforms.totalenergies.com/help-center/support-request'}>Request help</Link>)
}

export default RequestHelp